import { styled } from '@openeducation/oe-rn-themes';
import { rgba } from 'polished';
import * as React from 'react';
import { View } from 'react-native';

import { flex, mh } from '../../../style-utils';

export type EmojiDividerProps = {
  emoji: React.ReactNode;
};

export const EmojiDivider = ({ emoji }: EmojiDividerProps) => {
  return (
    <View
      style={[flex('flex-row', 'justify-content-center', 'align-items-center')]}
    >
      <DividerLine />
      <View style={[mh(10)]}>{emoji}</View>
      <DividerLine />
    </View>
  );
};

const DividerLine = styled.View`
  width: 100px;
  height: 2px;
  background-color: ${({ theme }) => rgba(theme.color.primary, 0.05)};
`;
